/**
 * Make it safe to str[...] or str.slice(...) without crashing
 * due to emoji
 */
export function safeUtf8StringSlice(str: string, start: number, end: number) {
  // [...name] splits the strings accounting for emoji
  return [...str].slice(start, end).join('');
}

/**
 * str.length, but accounting for emoji
 */
export function utf8StringLength(str: string) {
  return [...str].length;
}
